<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('editionClient.generalTitle.contactInformations')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field :label="$t('editionClient.informations.phone')">
            <b-input v-model="tiers.telephone"></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('editionClient.informations.cellPhone')">
            <b-input v-model="tiers.portable"></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <input-email :label="$t('editionClient.informations.email')"
                       v-model="tiers.email"/>
        </div>
        <div class="column is-6">
          <input-url  :label="$t('editionClient.informations.webSite')"
                      v-model="tiers.siteWeb"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputEmail from '@/components/general/inputEmail';
import inputUrl from '@/components/general/inputUrl';

export default {
  name: 'contactInformation',
  props: {
    tiers: {
      type: Object,
      required: true,
      default: null,
    },
  },
  components: {
    inputEmail,
    inputUrl,
  },
};
</script>

<style scoped>

</style>
